import { render, staticRenderFns } from "./ChiSiamo.vue?vue&type=template&id=a818e08a&scoped=true"
import script from "./ChiSiamo.vue?vue&type=script&lang=js"
export * from "./ChiSiamo.vue?vue&type=script&lang=js"
import style0 from "./ChiSiamo.vue?vue&type=style&index=0&id=a818e08a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a818e08a",
  null
  
)

export default component.exports